import { useField, useForm } from 'react-final-form';
import classNames from 'classnames';
import { RecipientOption } from './types';

export const SelectedRecipients = () => {
  const { change } = useForm();
  const {
    input: { value: recipients },
  } = useField<RecipientOption[]>('recipients', { subscription: { value: true } });

  if (!recipients?.length) return null;

  const removeRecipient = (recipientId: string) =>
    change(
      'recipients',
      recipients.filter(({ value }) => value !== recipientId)
    );

  return (
    <div className="row input-item-list">
      {recipients.map(({ value, label, unavailableReason }) => (
        <button
          key={value}
          type="button"
          className="input-item border-0"
          onClick={() => removeRecipient(value)}
          aria-label={`Remove ${label}`}
        >
          <span className={classNames('oath-utility', unavailableReason ? 'gray' : 'inkBlue')}>
            {unavailableReason ? `${label} (${unavailableReason})` : label}
          </span>
        </button>
      ))}
    </div>
  );
};
